import React, { useContext, useEffect, useRef, useState } from 'react';
import BearerMenu from './menu/BearerMenu';
// import BearerMap from './map/BearerMap'; // commented by Bearer Web Developer - change map api
import VersionAgreement from './remoteconfig/VersionAgreement';
import { Button, Dialog, Tab, Tabs, Tooltip } from '@mui/material'; // DialogActions, DialogContent, DialogContentText removed by Bearer Web Developer
import LeftSidePanel from './order/LeftSidePanel';
import { useAppState, } from '../states/app-state';
import { observer, Observer } from 'mobx-react-lite';
import CheckServerRunningStates from './remoteconfig/CheckServerRunningStates';
import CheckDevicesPopup from './login/CheckDevicesPopup';
import ErrorsPopup from './errors/ErrorsPopup';
import Notifier from './Notifier';
import IpAlertMessage from './ipAlertMessage'; // added by Bearer Web Developer
import styles from './Scaffold.module.scss'; // added by Bearer Web Developer
// useStyles removed by Bearer Web Developer
import Split from '@uiw/react-split'; // added by Bearer Web Developer
import { useMenuDrawer } from '../states/contexts/menuDrawer'; // added by Bearer Web Developer
import AddToHomeScreen from './addToHomeScreen'; // added by Bearer Web Developer
import FreeOrderPopup from './freeOrderPopup'; // added by Bearer Web Developer
import RequestPermissionPopup from './requestPermissionPopup';  // added by Bearer Web Developer
import AccessingFeatureMenu from './accessingFeatureMenu'; // added by Bearer Web Developer
import { AccessingFeatureMenuContext } from '../states/contexts/accessingFeatureMenu'; // added by Bearer Web Developer
import CompleteProfileButton from './menu/completeProfileButton'; // added by Bearer Web Developer
import Loading from './loading'; // added by Bearer Web Developer
import ToastMui from './toastMui'; // added by Bearer Web Developer
import InviteCode from './inviteCode'; // added by Bearer Web Developer
import ReservedOrdersPopup from './reservedOrdersPopup'; // added by Bearer Web Developer
import ApiIntegrationPopup from './apiIntegrationPopup'; // added by Bearer Web Developer
import TransportHistoriesPopup from './order/TransportHistoriesPopup';  // added by Bearer Web Developer - TransportHistoriesPopup moved from child component
import HamburgerMenu from './hamburgerMenu'; // added by Bearer Web Developer
import BearerHeaderLogo from './bearerHeaderLogo'; // added by Bearer Web Developer
import SwipeUP from './swipeUp'; // added by Bearer Web Developer
import { useThemeMode } from '../states/contexts/theme'; // added by Bearer Web Developer
import BearerMapApi from './map/BearerMapApi'; // added by Bearer Web Developer - change map api
import TodayDeliveries from './reservedOrdersPopup/todayDeliveries'; // added by Bearer Web Developer
import ShortcutOrdersManagement from './shortcutOrdersManagement'; // added by Bearer Web Developer
import CancelledByRiderAfterOriginPopup from './cancelledByRiderAfterOrigin'; // added by Bearer Web Developer
import ListedTabs from './listedTabs'; // added by Bearer Web Developer

const Scaffold: React.FC = observer(() => {

    const appState = useAppState();
    const sidebar = useRef(null);
    // added by Bearer Web Developer start
    const { theme } = useThemeMode();
    const { swipable, swipe, toggleMenuDrawer } = useMenuDrawer();
    const { reservedOrdersOpen } = appState?.ReservedOrders;
    const { apiIntegrationOpen } = appState?.ApiIntegration;
    const { transportHistoryOpen } = appState?.transportHistory;
    const { loggedin } = appState?.login;
    // move and change login state to loginState of mobx states by Bearer Web Developer
    const handleLoginPopup = () => {
        appState.login.setOpen(true); // modified by Bearer Web Developer (login state is moved to loginState of mobx states)
    }
    // added by Bearer Web Developer end
    // useEffect(() => {

    // }, [appState.serverChecked])
    // added by Bearer Web Developer start (FreeOrder)
    const handleCloseFreeOrder = () => {
        appState?.freeOrder?.setOpen(false);
    }
    // added by Bearer Web Developer end (FreeOrder)
    // added by Bearer Web Developer start (RequestPermission)
    const handleCloseRequestPermission = () => {
        appState?.requestPermission?.setOpen(false);
    }
    // added by Bearer Web Developer end (RequestPermission)
    // added by Bearer Web Developer start
    useEffect(() => {
        if (appState.serverChecked) {
            appState.selectedOrder?.setDefaultOrigin();
        }
    }, [appState.serverChecked, appState.selectedOrder]);
    // added by Bearer Web Developer end
    // added by Bearer Web Developer start
    const [tooltip, setTooltip] = useState<boolean>(false);
    const [accessingFeatureMenuElement, setAccessingFeatureMenuElement] = React.useState<null | HTMLElement>(null);
    const valueAccessingFeatureMenuElement = { accessingFeatureMenuElement, setAccessingFeatureMenuElement };
    useEffect(() => {
        if (appState.serverChecked) {
            if (appState.login.loggedin) {
                const { is_full_discount, fullDiscountUsedOnce } = appState?.fullDiscountAutomatically;
                appState?.freeOrder?.setOpen(is_full_discount && !fullDiscountUsedOnce);
            }
        }
    }, [appState.serverChecked]);
    useEffect(() => {
        if (appState.serverChecked) {
            setTooltip(true);
            setTimeout(() => { setTooltip(false) }, 3000);
        }
    }, [appState.serverChecked, appState.login.loggedin]);
    // added by Bearer Web Developer end
    // modified by Bearer Web Developer start
    return <>
        <div className={styles.mainContainer} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <AddToHomeScreen /> {/* AddToHomeScreen component added by Bearer Web Developer*/}
            {appState?.cancelledByRiderAfterOrigin?.open && <CancelledByRiderAfterOriginPopup />} {/* added by Bearer Web Developer */}
            {appState?.snackMessage && !appState?.cancelledByRiderAfterOrigin?.open && <Notifier />} {/* appState?.snackMessage and !appState?.cancelledByRiderAfterOrigin?.open conditions added by Bearer Web Developer*/}
            <TodayDeliveries /> {/* TodayDeliveries component added by Bearer Web Developer*/}
            {!appState.serverSync &&
                // circular_progress commented by Bearer Web Developer start
                // <div className={styles.circular_progress}>
                //     <CircularProgress className={styles.loader} />
                // </div>
                // circular_progress commented by Bearer Web Developer end
                <Loading /> // added by Bearer Web Developer 
            }
            {appState.serverSync &&
                <div>
                    {appState.serverChecked &&
                        <>
                            {/* FreeOrderPopup component in the following added by Bearer Web Developer*/}
                            {appState?.freeOrder?.open && <FreeOrderPopup open={appState?.freeOrder?.open} handleClose={handleCloseFreeOrder} />}
                            {/* RequestPermissionPopup component in the following added by Bearer Web RequestPermissionPopup*/}
                            {appState?.requestPermission?.open && <RequestPermissionPopup open={appState?.requestPermission?.open} handleClose={handleCloseRequestPermission} />}
                            {/* VerificationMenuContext wrapped by Bearer Web Developer start*/}
                            <AccessingFeatureMenuContext.Provider value={valueAccessingFeatureMenuElement}>
                                <div>
                                    {/* AccessingFeatureMenu component in the following added by Bearer Web Developer*/}
                                    {appState?.createAccount?.sign_up_stage > 0 && <AccessingFeatureMenu accessingFeatureMenuElement={accessingFeatureMenuElement} setAccessingFeatureMenuElement={setAccessingFeatureMenuElement} />}
                                    {/* Split wrapped by Bearer Web Developer start*/}
                                    <Split className={styles.container} visible={true}
                                        renderBar={({ onMouseDown, ...props }) => {
                                            return (
                                                <div {...props} style={{ boxShadow: 'none', background: theme === "dark" ? '#4D4D4D' : '#14438E' }}>
                                                    <div className={styles.adjustable} onMouseDown={onMouseDown}
                                                        style={{ background: theme === "dark" ? '#4D4D4D' : '#14438E', height: "100vh", width: "8px" }}>
                                                    </div>
                                                </div>
                                            );
                                        }}
                                    >
                                        <div className={styles.orderForm_container}>
                                            <div className={styles.orderForm} ref={sidebar} >
                                                <div className={styles.bearer_header}>
                                                    <div className={styles.login_menu}>
                                                        {/*modified by Bearer Web Developer, CompleteProfileButton added  start */}
                                                        {
                                                            loggedin ?
                                                                <div className={styles.hamburger_menu}>
                                                                    <span onClick={toggleMenuDrawer(true)}>
                                                                        <HamburgerMenu />
                                                                    </span>
                                                                </div>
                                                                : (appState?.createAccount?.sign_up_stage !== 0) ?
                                                                    <div className={styles.complete_profile_menu}><CompleteProfileButton /></div> :
                                                                    <Button onClick={handleLoginPopup} className={styles.login_mobile}  >
                                                                        <img src="/login-mobile.webp" width={33} height={33} alt="" />
                                                                    </Button>
                                                        }
                                                        {/*modified by Bearer Web Developer: CompleteProfileButton added  end */}
                                                    </div>
                                                    <div>
                                                        <BearerHeaderLogo /> {/* added by Bearer Web Developer */}
                                                    </div>
                                                    {/* added by Bearer Web Developer start*/}
                                                    {
                                                        <div className={styles.whatsapp}>
                                                            <a target='_blank' href={appState?.webAppRemoteConfigParameters?.whatsappLiveSupportNumber}>
                                                                <Tooltip title={"Whatsapp Live Chat"} arrow={true} open={tooltip}
                                                                    classes={{ tooltip: styles.tooltip, arrow: styles.arrow }}
                                                                >
                                                                    <img className={styles.whatsapp_image} src="/whatsapp.svg" alt="" width={48} height={48} />
                                                                </Tooltip>
                                                            </a>
                                                        </div>
                                                    }
                                                    {/* added by Bearer Web Developer end*/}
                                                </div>
                                                <ToastMui handleClose={appState?.limittedOrdersToast?.handleCloseToast} open={appState?.limittedOrdersToast?.open} /> {/* added by Bearer Web Developer */}
                                                <OrderTabs />
                                                <LeftSidePanel />
                                                <ShortcutOrdersManagement /> {/* ShortcutOrdersManagement component added by Bearer Web Developer */}
                                                {/**  Put temp stuff here, it will be show below the scrolled div */}
                                            </div>
                                        </div>
                                        <div style={{ minWidth: 80, flex: 1 }}>
                                            <div className={styles.map_container}>
                                                <BearerMenu />
                                                <div className={`${styles.map} ${!swipe ? styles.map_mobile : ''} ${!appState.login.loggedin ? styles.map_mobile_logout : ""}`}>
                                                    <div className={styles.swipable} onClick={swipable}>
                                                        {
                                                            swipe ?
                                                                <>
                                                                    {theme === "dark" ?
                                                                        <img src="/expand-address.png" alt="" width={24} height={24} /> :
                                                                        <img src="/expand_more_black.png" alt="" width={24} height={24} />}
                                                                    {/* <div className={styles.bar}></div> */}
                                                                </>
                                                                :
                                                                <SwipeUP /> // SwipeUP added by Bearer Web Developer
                                                        }
                                                    </div>
                                                    {/* added by Bearer Web Developer start*/}
                                                    {
                                                        loggedin && appState?.inviteCode?.value && appState?.inviteCode?.open &&
                                                        <div className={styles.invite_code_desktop}><InviteCode /></div>
                                                    }
                                                    {/* added by Bearer Web Developer end*/}
                                                    <div className={`${styles.bearer_map} ${!swipe ? styles.bearer_map_mobile : ''}`}>
                                                        {loggedin && reservedOrdersOpen && <ReservedOrdersPopup />} {/* added by Bearer Web Developer */}
                                                        {loggedin && apiIntegrationOpen && <ApiIntegrationPopup />} {/* added by Bearer Web Developer */}
                                                        {loggedin && transportHistoryOpen && <TransportHistoriesPopup />} {/* TransportHistoriesPopup moved here from child component by Bearer Web Developer */}
                                                        {/* <BearerMap /> */} {/* commented by Bearer Web Developer - change map api */}
                                                        <BearerMapApi /> {/* added by Bearer Web Developer - change map api */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Split>
                                    {/* Split wrapped by Bearer Web Developer end*/}
                                </div>
                            </AccessingFeatureMenuContext.Provider>
                            {/* VerificationMenuContext wrapped by Bearer Web Developer end*/}
                            {/* the following IpAlertMessage added by Bearer Web Developer */}
                            {appState.profile.ipAlertMessage && <IpAlertMessage />}
                            <VersionAgreement />
                            <SimpleMessagesDialog />
                            <ErrorsPopup />
                        </>
                    }
                    {!appState.serverChecked && <CheckServerRunningStates />}
                    <CheckDevicesPopup />
                </div>
            }

        </div>
    </>
    // modified by Bearer Web Developer end
});
export default Scaffold;



const OrderTabs: React.FC = observer(() => {
    const appState = useAppState();

    const handleSelect = (event: React.ChangeEvent<{}>, value: number) => {
        if (value >= 0) {
            appState.selectOrder(value);
        }
    };

    const ordersLimit = appState.profile.orderLimits!;
    const login = appState.login.loggedin;
    // modified by Bearer Web Developer start (add sign_up_stage condition and AccessingFeatureMenu)
    const { setAccessingFeatureMenuElement } = useContext(AccessingFeatureMenuContext);
    const handleAddNew = async (event: React.MouseEvent<HTMLButtonElement>) => {
        if (appState?.createAccount?.sign_up_stage > 0 && appState?.createAccount?.sign_up_stage < 3) {
            setAccessingFeatureMenuElement(event?.currentTarget);
            return;
        }
        if ((login && appState.orders.length < ordersLimit) || (!login && appState.orders.length <= 0)) {
            await appState.addOrder();
            appState.selectOrder(appState.orders.length - 1);
            return true; // added by Bearer Web Developer
        } else if (login && appState.orders.length >= ordersLimit) { // added by Bearer Web Developer start
            // reaching the maximum number of orders allowed
            appState?.limittedOrdersToast?.handleOpenToast();
        } // added by Bearer Web Developer end

        return false;
    };
    // modified by Bearer Web Developer end (add sign_up_stage condition and AccessingFeatureMenu)
    // modified by Bearer Web Developer start
    React.useEffect(() => {
        if (!login) {
            (async () => {
                await appState.addOneOrder();
                appState.selectOrder(appState.orders.length - 1);
            })();
        }
    }, [appState, login])
    // modified by Bearer Web Developer end
    // modified by Bearer Web Developer start
    return (
        <Observer>
                {() => (
                    <>
                    {
                        appState.orders.length < 4 ? // This Condition added by Bearer Web Developer
                        <Tabs
                            variant="scrollable"
                            scrollButtons={appState.orders.length === 3 ? true : false}
                            // orientation="vertical"
                            classes={{
                                root: styles.root_tabs,
                                flexContainer:
                                    appState.orders.length > 2 ? '' : appState.orders.length > 1 ?
                                        styles.flex_container_more_than_one_tabs : styles.flex_container
                            }}
                            slots={{
                                scrollButtons: (props) => {
                                    return <Button onClick={props.onClick}
                                        className={`
                                            ${styles.scroll_buttons}
                                            ${props.direction === "right" ? styles.scroll_button_right : styles.scroll_button_left}`}
                                    >
                                        {<img className={styles.mark} src={`/expand_more_${props.direction === "right" ? "right" : "left"}.png`} alt="" width={13} height={18} />}
                                        <div className={styles.shadow}></div>
                                    </Button>
                                }
                            }}

                            value={appState.selectedOrderIndex}
                            onChange={handleSelect}
                            className={styles.tabs}
                            TabIndicatorProps={{ hidden: true }}
                        >
                                
                                    {appState.orders.map((o, i) => {
                                        // modified by Bearer Web Developer start
                                        const ReservedTab = appState?.orders[i]?.selectedReservedOrder; // added by Bearer Web Developer
                                        const clientOrderNumber = appState?.orders[i]?.clientOrderNumber; // added by Bearer Web Developer
                                        const selected = appState?.selectedOrderIndex === i;
                                        const searchRiderChanged = appState?.orders[i]?.searchRider?.changeData; // added by Bearer Web Developer
                                        const chatChanged = appState?.orders[i]?.chat?.changeData; // added by Bearer Web Developer
                                        return <Tab key={i} style={{ margin: 0, padding: 0, textTransform: "none" }} className={appState.orders.length < 3 ? styles.tab_main : ""}
                                            icon={
                                                <div
                                                    className={
                                                        `${styles.tab} ${selected ? appState.orders.length < 2 ? styles.selected_tab_one_order : styles.selected_tab : searchRiderChanged ? styles.search_rider_changed : chatChanged ? styles.chat_changed : ''} ${ReservedTab && appState.orders.length === 2 ? styles.reserved_two_tab : ''} ${i === 0 ? styles.order_one : ''} ${appState.orders.length === 3 ? styles.more_tabs_three : appState.orders.length > 2 ? styles.more_tabs : appState.orders.length > 1 ? styles.more_than_one_tabs : styles.one_tab}`
                                                    }
                                                >{ReservedTab ? `Order #: ${ReservedTab?.client_order_number}` : clientOrderNumber ? `Order #: ${clientOrderNumber}` : ('Order ' + (i + 1))}</div>}
                                            value={i} />
                                        // modified by Bearer Web Developer end
                                    })}
                                    <Tab style={{ margin: 0, padding: 0, textTransform: "none" }} className={appState.orders.length < 3 ? styles.tab_main : ""} 
                                    icon={
                                        <div className={`${styles.add_order} ${appState.orders.length === 3 ? styles.add_order_more_tabs_three : appState.orders.length > 2 ? styles.add_order_more_tabs : appState.orders.length > 1 ? styles.add_order_more_than_one_tabs : styles.add_order_one_tab}`}
                                        >
                                            {appState.orders.length > 1 ? "+ Add" : "+ Add Order"}
                                        </div>} value={-1} onClick={handleAddNew as any} />
                        </Tabs>
                        : <ListedTabs handleAddNew={handleAddNew} handleSelect={handleSelect} /> // ListedTabs Component added by Bearer Web Developer
                    }
                    </>
                )}
            </Observer>
    )
    // modified by Bearer Web Developer end
})

const SimpleMessagesDialog: React.FC = observer(() => {
    const appState = useAppState();
    const simpleMessages = appState.simpleMessages;
    const open = simpleMessages.length > 0;
    const simpleMessage = open ? simpleMessages[0] : undefined;
    const handleRemoveMessage = () => {
        appState.removeLastMessage();
    }
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    // modified by Bearer Web Developer start
    return (
        <>
            <Dialog open={open}
                slotProps={{
                    paper: {
                        sx: {
                            borderRadius: "10px",
                            backgroundColor: theme === "dark" ? 'var(--neutral-hsb-30, #4D4D4D)' : '#fff'
                        },
                        classes: { root: styles.root }
                    },
                }}
            >
                <div className={styles.simple_messages_dialog} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
                    {simpleMessage && <p>{simpleMessage?.message}</p>}
                    <Button onClick={handleRemoveMessage} className={styles.button}>
                        <span>OK</span>
                    </Button>
                </div>
            </Dialog>
        </>
    )
    // modified by Bearer Web Developer end
})



